(function () {
  OverbookedController.$inject = ["$routeParams", "$location", "$rootScope", "$filter"];
  angular.module('calendarApp').controller('OverbookedController', OverbookedController);

  function OverbookedController($routeParams, $location, $rootScope, $filter) {
    var over = this;

    over.init = function () {
      if (!$rootScope.overBooked || !$rootScope.overBooked.length) {
        return $location.path($routeParams.referrer || '/');
      } // Show appointments which can be booked


      var appointments = localStorage.getItem('reserved-appointments');
      over.appointments = appointments ? JSON.parse(appointments) : [];
      over.doWaitlist = over.appointments.find(function (appt) {
        return appt.serviceid && appt.serviceid.waitlist;
      }); // Overbooked appointments

      over.overBooked = $rootScope.overBooked;
      over.timeSettings = smooth.timeSettings;
      moment.tz.setDefault(over.timeSettings.timezone);
    };

    over.init();

    over.continue = function () {
      // What happens next depends on who the referrer was
      delete $rootScope.overBooked;

      if (!over.appointments || !over.appointments.length) {
        return $location.path('/review');
      }

      if ($routeParams.referrer === 'chooseslots') {
        if (smooth.calendarSettings.bookfuturedays) {
          $location.path('/futureslots');
        } else {
          $location.path('/review');
        }
      } else {
        $location.path('/review');
      }
    };

    over.chooseWaitlist = function (timeslot, shift) {
      over.waitlistModal(timeslot, over.shift);
    };

    over.cancel = function () {
      if (over.appointments && over.appointments.length) {
        var cancelMessage = $filter('calendarLabel')('This will remove your reserved appointments. Continue?');

        if (!confirm(cancelMessage)) {
          return;
        }
      }

      $location.path('/');
    };
  }
})();